export const WARD_TOUR_STORAGE_KEY = 'cityExplorer:wardMapTour:v1';
export const WARD_DATA_SOURCES_STEP_INDEX = 4;

export const isWardCategoryId = (id) => String(id || '').toLowerCase().includes('ward');

export const locationHasWardMaps = (categories = []) =>
  categories.some((category) => isWardCategoryId(category?.id));

export const isWardMapItem = (item) => item?.type === 'map' && isWardCategoryId(item.category?.id);

export const WARD_TOUR_STEPS = [
  {
    id: 'shading',
    title: 'Ward shading',
    body: 'Newark’s five wards are colored by projected K–12 child population change from 2026 to 2031. Red means decline, gray is roughly flat, and green means growth. The scale is in the legend below the map.',
    spotlight: 'legend-box',
  },
  {
    id: 'hover-zoom',
    title: 'Hover and zoom',
    body: 'Hover a ward to see its population, trend, and charter share. Use the + and − buttons in the top left to zoom, or scroll or pinch. Click a ward in the legend to fly there.',
    spotlight: 'map-zoom',
    spotlightLabel: 'Zoom',
  },
  {
    id: 'school-popups',
    title: 'School details',
    body: 'Click a school marker to open a pop-up with enrollment, grades, and which ward it belongs to. The highlighted card is an example of what you will see.',
    spotlight: 'example-popup',
  },
  {
    id: 'school-markers',
    title: 'School markers',
    body: 'Filled circles are charter schools; squares are district schools. A marker’s fill color matches the school’s ward — not the red-to-green growth scale, and not a quality rating.',
    spotlight: 'map-schools-east',
    spotlightLabel: 'Circles and squares',
  },
  {
    id: 'data-sources',
    title: 'Data sources',
    body: 'Methodology notes and the spreadsheets behind this map are in the left panel under Data Sources and Documentation, next to Data Sets.',
    cardAlign: 'bottom-left',
  },
];

export const readWardTourDismissed = () => {
  try {
    return window.localStorage.getItem(WARD_TOUR_STORAGE_KEY) === '1';
  } catch (_err) {
    return false;
  }
};

export const writeWardTourDismissed = () => {
  try {
    window.localStorage.setItem(WARD_TOUR_STORAGE_KEY, '1');
  } catch (_err) {
    // Private browsing or disabled storage should not break the map.
  }
};

export const shouldShowWardTour = ({
  hasWardCategory,
  viewingWardMap,
  mapLoaded,
  isFullscreen,
  dismissed,
  replaying,
}) =>
  Boolean(hasWardCategory && viewingWardMap && mapLoaded && !isFullscreen && (!dismissed || replaying));
